var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConnplexLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1004.46 220.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: url(#linear-gradient-2);\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: url(#linear-gradient-6);\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: url(#linear-gradient-5);\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: url(#linear-gradient-7);\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: url(#linear-gradient-9);\r\n      }\r\n\r\n      .cls-7 {\r\n        fill: url(#linear-gradient-3);\r\n      }\r\n\r\n      .cls-8 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n\r\n      .cls-9 {\r\n        fill: url(#linear-gradient-4);\r\n      }\r\n\r\n      .cls-10 {\r\n        fill: url(#linear-gradient-8);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 69.45,
    y1: -135.49,
    x2: 42.63,
    y2: 410.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbf395"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#f9e77d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#f8dc66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#e6c85b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#c5a045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#ad8435"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#9e732c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#996d29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#9d722c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#a98136"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#bd9b46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#d9bf5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#fae878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#fbf5ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#fae878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a46427"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 204.06,
    y1: -128.88,
    x2: 177.23,
    y2: 417.48,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 345.84,
    y1: -121.92,
    x2: 319.02,
    y2: 424.44,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 486.3,
    y1: -115.02,
    x2: 459.48,
    y2: 431.33,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 614.19,
    y1: -108.74,
    x2: 587.36,
    y2: 437.61,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 729.12,
    y1: -103.1,
    x2: 702.29,
    y2: 443.25,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 835.26,
    y1: -97.89,
    x2: 808.44,
    y2: 448.47,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 948.29,
    y1: -92.34,
    x2: 921.46,
    y2: 454.01,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0,
    y1: 206.17,
    x2: 538.79,
    y2: 206.17,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m67.4,0c27,0,46.8,9.8,46.8,9.8v35s-24-13.8-47-10.8c-25.4,3-36.2,19.6-36.2,40s10.8,37.6,36.4,39.2c27,2,49.4-12.6,48.6-12l-.6,35.6s-18.4,11-48,11C23.2,147.8,0,118.2,0,74S23,0,67.4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m194.2,0c44.2,0,67.2,29.6,67.2,74s-23,73.8-67.2,73.8-67.4-29.6-67.4-73.8S149.8,0,194.2,0Zm0,115c24,0,34.6-20.8,34.6-41s-10.6-41.2-34.6-41.2-34.6,20.8-34.6,41.2,10.8,41,34.6,41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m274.4,4.6h44.2l46.8,96.6V4.6h32.6v140h-42.2l-48.8-100.8v100.8h-32.6V4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m415.19,4.6h44.2l46.8,96.6V4.6h32.6v140h-42.2l-48.8-100.8v100.8h-32.6V4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m555.99,4.6h36.6c48.4,0,66.2,13,66.2,47.8s-18,48.4-66.2,48.4h-4v43.8h-32.6V4.6Zm33.2,68.6c22.6,0,37.4.2,37.2-20.6-.2-21-14.8-20.6-37.2-20.6h-.6v41.2h.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m673.59,4.6h32.8v112.4h60.8v27.6h-93.6V4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m779.99,4.6h93.6v27.4h-60.8v28.6h57v27.6h-57v28.8h60.8v27.6h-93.6V4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m939.99,108.6l-19.8,36h-37.2l38.4-70-38.4-70h37.4l19.6,36,19.8-36h37.2l-38.4,70,38.6,70h-37.4l-19.8-36Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    y: 205.86,
    width: 538.79,
    height: 0.61
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m582.27,189.84c-1.04-1.17-2.43-2.13-4.17-2.85-1.75-.73-3.71-1.09-5.88-1.09-3.28,0-5.67.61-7.15,1.84-1.49,1.23-2.23,2.89-2.23,5,0,1.11.2,2.01.6,2.72.4.71,1.02,1.32,1.87,1.84.85.52,1.92.97,3.21,1.35,1.3.38,2.83.76,4.59,1.14,1.97.42,3.73.87,5.29,1.37,1.55.5,2.88,1.14,3.99,1.92,1.11.78,1.95,1.73,2.54,2.85.59,1.12.88,2.51.88,4.17s-.33,3.16-.99,4.41-1.57,2.28-2.75,3.11-2.57,1.44-4.2,1.84c-1.63.4-3.39.6-5.29.6-5.77,0-10.7-1.78-14.77-5.34l1.76-2.95c1.35,1.42,3.16,2.62,5.44,3.6,2.28.98,4.82,1.48,7.62,1.48,2.94,0,5.24-.53,6.89-1.58,1.66-1.05,2.49-2.65,2.49-4.79,0-1.14-.23-2.1-.7-2.88-.47-.78-1.17-1.45-2.1-2.02s-2.1-1.06-3.5-1.48c-1.4-.41-3.01-.83-4.85-1.24-1.94-.45-3.63-.92-5.08-1.4-1.45-.48-2.67-1.09-3.65-1.81-.99-.73-1.73-1.6-2.23-2.62-.5-1.02-.75-2.27-.75-3.76,0-1.69.32-3.21.96-4.54.64-1.33,1.54-2.44,2.7-3.32,1.16-.88,2.54-1.56,4.15-2.02,1.61-.47,3.38-.7,5.31-.7,2.42,0,4.59.37,6.5,1.11,1.92.74,3.65,1.79,5.21,3.14l-1.71,2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m624.98,219.74v-30.22l-13.42,23.38h-2.13l-13.48-23.38v30.22h-3.58v-36.8h3.68l14.41,25.19,14.41-25.19h3.68v36.8h-3.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m634,219.74l15.39-36.8h2.96l15.39,36.8h-3.89l-4.77-11.51h-16.54l-4.72,11.51h-3.84Zm16.9-32.55l-7.57,18.19h14.93l-7.36-18.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m673.08,219.74v-36.8h15.5c1.59,0,3.06.34,4.41,1.01s2.5,1.55,3.47,2.64c.97,1.09,1.72,2.32,2.25,3.71.54,1.38.8,2.78.8,4.2s-.2,2.64-.6,3.86c-.4,1.23-.96,2.33-1.69,3.32-.73.99-1.59,1.81-2.59,2.49-1,.67-2.13,1.13-3.37,1.37l9.07,14.2h-4.09l-8.71-13.58h-10.89v13.58h-3.58Zm3.58-16.79h12.08c1.07,0,2.05-.23,2.93-.7.88-.47,1.63-1.1,2.25-1.89.62-.79,1.11-1.69,1.45-2.7.34-1,.52-2.06.52-3.16s-.2-2.17-.6-3.19c-.4-1.02-.93-1.91-1.61-2.67-.67-.76-1.47-1.36-2.38-1.81-.92-.45-1.88-.67-2.88-.67h-11.77v16.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m732.59,186.16h-13.11v33.59h-3.63v-33.59h-13.11v-3.21h29.86v3.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m774.89,186.16h-13.11v33.59h-3.63v-33.59h-13.11v-3.21h29.86v3.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m809.56,182.94v36.8h-3.63v-17.21h-21.82v17.21h-3.58v-36.8h3.58v16.38h21.82v-16.38h3.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m843.57,216.53v3.21h-24.72v-36.8h24.26v3.21h-20.68v13.27h18.04v3.06h-18.04v14.05h21.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m846.73,219.74l15.39-36.8h2.96l15.39,36.8h-3.89l-4.77-11.51h-16.54l-4.72,11.51h-3.84Zm16.9-32.55l-7.57,18.19h14.93l-7.36-18.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m908.31,186.16h-13.11v33.59h-3.63v-33.59h-13.11v-3.21h29.86v3.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m913.96,219.74v-36.8h15.5c1.59,0,3.06.34,4.41,1.01s2.5,1.55,3.47,2.64c.97,1.09,1.72,2.32,2.25,3.71.54,1.38.8,2.78.8,4.2s-.2,2.64-.6,3.86c-.4,1.23-.96,2.33-1.69,3.32-.73.99-1.59,1.81-2.59,2.49-1,.67-2.13,1.13-3.37,1.37l9.07,14.2h-4.09l-8.71-13.58h-10.89v13.58h-3.58Zm3.58-16.79h12.08c1.07,0,2.05-.23,2.93-.7.88-.47,1.63-1.1,2.25-1.89.62-.79,1.11-1.69,1.45-2.7.34-1,.52-2.06.52-3.16s-.2-2.17-.6-3.19c-.4-1.02-.93-1.91-1.61-2.67-.67-.76-1.47-1.36-2.38-1.81-.92-.45-1.88-.67-2.88-.67h-11.77v16.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m972.89,216.53v3.21h-24.72v-36.8h24.26v3.21h-20.68v13.27h18.04v3.06h-18.04v14.05h21.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1000.93,189.84c-1.04-1.17-2.43-2.13-4.17-2.85-1.75-.73-3.71-1.09-5.88-1.09-3.28,0-5.67.61-7.15,1.84-1.49,1.23-2.23,2.89-2.23,5,0,1.11.2,2.01.6,2.72.4.71,1.02,1.32,1.87,1.84.85.52,1.92.97,3.21,1.35,1.3.38,2.83.76,4.59,1.14,1.97.42,3.73.87,5.29,1.37,1.55.5,2.88,1.14,3.99,1.92,1.11.78,1.95,1.73,2.54,2.85.59,1.12.88,2.51.88,4.17s-.33,3.16-.99,4.41-1.57,2.28-2.75,3.11-2.57,1.44-4.2,1.84c-1.63.4-3.39.6-5.29.6-5.77,0-10.7-1.78-14.77-5.34l1.76-2.95c1.35,1.42,3.16,2.62,5.44,3.6,2.28.98,4.82,1.48,7.62,1.48,2.94,0,5.24-.53,6.89-1.58,1.66-1.05,2.49-2.65,2.49-4.79,0-1.14-.23-2.1-.7-2.88-.47-.78-1.17-1.45-2.1-2.02s-2.1-1.06-3.5-1.48c-1.4-.41-3.01-.83-4.85-1.24-1.94-.45-3.63-.92-5.08-1.4-1.45-.48-2.67-1.09-3.65-1.81-.99-.73-1.73-1.6-2.23-2.62-.5-1.02-.75-2.27-.75-3.76,0-1.69.32-3.21.96-4.54.64-1.33,1.54-2.44,2.7-3.32,1.16-.88,2.54-1.56,4.15-2.02,1.61-.47,3.38-.7,5.31-.7,2.42,0,4.59.37,6.5,1.11,1.92.74,3.65,1.79,5.21,3.14l-1.71,2.9Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnplexLogo);
export default __webpack_public_path__ + "static/media/connplexLogo.0b9f45340e6a6c3d956be708792afb51.svg";
export { ForwardRef as ReactComponent };